import React from "react";
import { useNavigate } from "react-router-dom";
import "./Stone.css";
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const PlantingIrrigation = () => {
  const navigate = useNavigate();

  const goToQuoteForm = () => {
    sessionStorage.setItem("scrollToQuote", "true");
    navigate("/");
  };

  return (
    <div className="stone-page">
      <Header />
      {/* Hero Section */}
      <section className="stone-hero">
        <h1>Planting & Irrigation Services</h1>
        <p>
          Enhance your landscape with vibrant plantings and efficient irrigation systems tailored to your property.
        </p>
      </section>

      {/* Services Highlights */}
      <section className="stone-services">
        <div className="stone-card-grid">
          {[
            {
              title: "Custom Planting Plans",
              description: "Design and install plantings that thrive in your climate and soil.",
            },
            {
              title: "Irrigation System Design",
              description: "Smart irrigation systems that conserve water and keep your landscape healthy.",
            },
            {
              title: "Drip & Sprinkler Installation",
              description: "Efficient solutions for gardens, lawns, and flower beds.",
            },
            {
              title: "Seasonal Plant Maintenance",
              description: "We care for your plants year-round with pruning, fertilizing, and replacement.",
            },
          ].map((item, i) => (
            <div className="stone-card" key={i}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Image Grid */}
      <section className="stone-gallery">
        {["planting1.jpg", "planting2.jpg", "planting3.jpg"].map((img, i) => (
          <img
            key={i}
            src={`/images/${img}`}
            alt={`Planting and Irrigation ${i + 1}`}
          />
        ))}
      </section>

      {/* CTA Section */}
      <section className="stone-cta">
        <p>
          Bring life to your yard with beautiful plantings and smart irrigation. Let's create something green and lasting.
        </p>
        <button
          onClick={goToQuoteForm}
          style={{
            backgroundColor: "#2E7D32",
            color: "white",
            border: "none",
            padding: "12px 30px",
            fontSize: "1rem",
            borderRadius: "8px",
            cursor: "pointer",
          }}
        >
          Request an Estimate <span className="cta-arrow">→</span>
        </button>
      </section>
      <Footer />
    </div>
  );
};

export default PlantingIrrigation;
